import { useState } from 'react'
import { styled } from '@mui/material/styles'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import { ExpandMoreIcon } from '@weblite/icons'
import { PageWithAppBar } from '$common/page-with-app-bar'
import { AppBarBackTitle } from '$common/app-bar/app-bar-back-title'
import { SettingsSection } from '$common/settings-section'
import { closeFAQ } from '$logic/router'
import { t } from '$i18n'

const AccordionStyled = styled(Accordion)`
  padding: 8px 20px;
  &.Mui-expanded {
    margin: 0;
  }
  .MuiAccordionSummary-root {
    font-size: ${({ theme }) => theme.typography.titleMedium.fontSize}px;
    font-weight: ${({ theme }) => theme.typography.titleMedium.fontWeight};
    line-height: ${({ theme }) => theme.typography.titleMedium.lineHeight};
    padding: 0;
    min-height: 40px;
    &.Mui-expanded {
      min-height: 56px;
    }
  }
  :before {
    display: none;
  }
  .MuiAccordionDetails-root {
    font-size: ${({ theme }) => theme.typography.titleRegular.fontSize}px;
    font-weight: ${({ theme }) => theme.typography.titleRegular.fontWeight};
    line-height: ${({ theme }) => theme.typography.titleRegular.lineHeight};
    padding: 0 0 4px 0;
  }
  :not(:last-of-type) {
    border-bottom: 1px solid ${({ theme }) => theme.palette.neutral100};
  }
`

const AccordionSummaryStyled = styled(AccordionSummary)`
  & .MuiAccordionSummary-content {
    padding: 0;
    margin: 8px 0;
    &.Mui-expanded {
      margin: 16px 0;
    }
  }
`
const AccordionDetailsStyled = styled(AccordionDetails)`
  .MuiAccordionDetails-root {
    padding: 0 4px 0 0;
  }
`

function FAQItem({
  title,
  description,
  expanded,
  onChange,
}: {
  title: string
  description: string
  expanded: boolean
  onChange: (expanded: boolean) => void
}) {
  return (
    <AccordionStyled
      elevation={0}
      onChange={(_, expanded) => onChange(expanded)}
      expanded={expanded}
    >
      <AccordionSummaryStyled expandIcon={<ExpandMoreIcon color="secondary" />}>
        {title}
      </AccordionSummaryStyled>
      <AccordionDetailsStyled>{description}</AccordionDetailsStyled>
    </AccordionStyled>
  )
}

export function FAQ() {
  const [expandedPanel, setExpandedPanel] = useState<string>()

  const onChange = (panel: string) => (expanded: boolean) => {
    setExpandedPanel(expanded ? panel : undefined)
  }

  return (
    <PageWithAppBar
      appBar={<AppBarBackTitle title={t('myAccount.faq')} onBack={closeFAQ} />}
    >
      <SettingsSection>
        {FAQ_ITEMS.map((item, index) => (
          <FAQItem
            title={item.title}
            description={item.description}
            expanded={expandedPanel === `panel-${index}`}
            onChange={onChange(`panel-${index}`)}
          />
        ))}
      </SettingsSection>
    </PageWithAppBar>
  )
}

const FAQ_ITEMS = Array(9)
  .fill(null)
  .map((_, index) => ({
    title: t(`myAccount.q${index + 1}.title`),
    description: t(`myAccount.q${index + 1}.description`),
  }))
